module.exports = __webpack_public_path__ + "static/media/044.803881e8.png";